export const Details = [
{id:'personalDetails', name: 'Personal Details', subText:'Details about your personal information'},
{id:'BusinessDetails', name: 'Business Details', subText:'Details about your business'},
{id:'bankDetails', name: 'Bank Details', subText:'Details about your banK and KYC documents'},
]

export const DetailsObj = [
    {name:'Ramya',
    mobile:9620354519,
    email:'ramyashankarj@gmail.com',
    shopName:'Ramya Electronics',
    businessType:'Retailer',
    category:'Large Appliances',
    shopNo:'234',
    line1:'Padmanabnagar',
    line2:'Padmanabnagar',
    city:'Bangalore',
    state:'Karnataka',
    pincode:"560061",
    pan:'CQAPR9810F',
    gst:'72362382389',
    bankName:'State Bank Of India',
    accountNo:'9723827324989',
    IFSC:'FRFF4556',
    nameOfHolder:'Ramya'

}
]